var __isp_options = {
    isp_serp_callback: function() {
        if ($jquery_isp('#ly-languages-switcher').val() === "ly55161") {
            $jquery_isp('.isp_facet_categories .isp_facet_value_name').each(function() {
                $jquery_isp(this).text(
                    $jquery_isp(this).text().replace('Best Sellers', "Meilleures ventes")
                        .replace('Home page', "Page d'accueil")
                        .replace('Bags', "Sacs")
                        .replace('Chef Hats and Hair Restraints', "Toques de chef et filets pour cheveux")
                        .replace('Crayons', "Crayons de cire")
                        .replace('Disposable Cutlery', "Couverts jetables")
                        .replace('Filters', "Filtres")
                        .replace('Gloves', "Gants")
                        .replace('Grill Bricks', "Briques à gril")
                        .replace('Guest Checks', "Livrets de vente")
                        .replace('Label Dispensers', "Distributeurs d'étiquettes")
                        .replace('Labels', "Étiquettes")
                        .replace('Lice Squad Boxes', "Boîtes 'Lice Squad'")
                        .replace('Muddlers', "Agitateurs")
                        .replace('Napkin Bands', "Bandes de serviette")
                        .replace('Picks and Skewers', "Piques et brochettes")
                        .replace('Pizza Holders', "Trépied à pizza")
                        .replace('Protective Wear', "Articles de protection")
                        .replace('Register Rolls', "Rouleaux de caisse")
                        .replace('Stirrers and Straws', "Agitateurs et pailles")
                        .replace('Swipes', "Swipes")
                        .replace('Containers and Cups', "Contenants et tasses à emporter")
                        .replace('Towels and Sponges', "Linges et éponges")
                        .replace('Twist Ties and Twine', "Attaches torsadées et ficelle")
                        .replace('Wipes', "Lingettes")
                        .replace('Beard Protectors', "Filets de barbe")
                        .replace('Chef Hats', "Toques de chef")
                        .replace('Chopsticks', "Baguettes")
                        .replace('Cups and Lids', "Tasses et couvercles")
                        .replace('Foodservice', "Restauration")
                        .replace('Foodservice Gloves', "Gants pour restauration")
                        .replace('Forks', "Fourchettes")
                        .replace('Garbage Bags', "Sacs poubelle")
                        .replace('Grocery Bags', "Sacs d'épicerie")
                        .replace('Hairnets and Bouffant Caps', "Filets pour cheveux et chapeaux bouffants")
                        .replace('Institutional', "Institutionnel")
                        .replace('Janitorial and Sanitation', "Nettoyage")
                        .replace('Knives', "Couteaux")
                        .replace('Latex Gloves', "Gants en latex")
                        .replace('Meal Kits', "Trousses de repas")
                        .replace('Medical', "Médical")
                        .replace('Medical Gloves', "Gants médicaux")
                        .replace('Nitrile Gloves', "Gants en nitrile")
                        .replace('Our Markets', "Nos Marchés")
                        .replace('Picks and Accessories', "Piques")
                        .replace('Plates and Bowls', "Assiettes et bols")
                        .replace('Poly Bags', "Sacs en poly")
                        .replace('Retail', "Vente au détail")
                        .replace('Rubber Gloves', "Gants en caoutchouc")
                        .replace('Saddle Bags', "Sacs de selle")
                        .replace('Skewers', "Brochettes")
                        .replace('Spoons', "Cuillères")
                        .replace('Steak Markers', "Marqueurs de steak")
                        .replace('Stirrers', "Mélangeurs")
                        .replace('Straws', "Pailles")
                        .replace('Takeout Containers', "Contenants à emporter")
                        .replace('Vinyl Gloves', "Gants en vinyle")
                        .replace('More info', "Plus d'Infos")
                        .replace('Eco-Friendly Products', "Produits Écologiques")
                );
            });
            $jquery_isp('#isp_results_summary').text(
                $jquery_isp('#isp_results_summary').text().replace('Best Sellers', "Meilleures ventes")
                        .replace('Home page', "Page d'accueil")
                        .replace('Bags', "Sacs")
                        .replace('Chef Hats and Hair Restraints', "Toques de chef et filets pour cheveux")
                        .replace('Crayons', "Crayons de cire")
                        .replace('Disposable Cutlery', "Couverts jetables")
                        .replace('Filters', "Filtres")
                        .replace('Gloves', "Gants")
                        .replace('Grill Bricks', "Briques à gril")
                        .replace('Guest Checks', "Livrets de vente")
                        .replace('Label Dispensers', "Distributeurs d'étiquettes")
                        .replace('Labels', "Étiquettes")
                        .replace('Lice Squad Boxes', "Boîtes 'Lice Squad'")
                        .replace('Muddlers', "Agitateurs")
                        .replace('Napkin Bands', "Bandes de serviette")
                        .replace('Picks and Skewers', "Piques et brochettes")
                        .replace('Pizza Holders', "Trépied à pizza")
                        .replace('Protective Wear', "Articles de protection")
                        .replace('Register Rolls', "Rouleaux de caisse")
                        .replace('Stirrers and Straws', "Agitateurs et pailles")
                        .replace('Swipes', "Swipes")
                        .replace('Containers and Cups', "Contenants et tasses à emporter")
                        .replace('Towels and Sponges', "Linges et éponges")
                        .replace('Twist Ties and Twine', "Attaches torsadées et ficelle")
                        .replace('Wipes', "Lingettes")
                        .replace('Beard Protectors', "Filets de barbe")
                        .replace('Chef Hats', "Toques de chef")
                        .replace('Chopsticks', "Baguettes")
                        .replace('Cups and Lids', "Tasses et couvercles")
                        .replace('Foodservice', "Restauration")
                        .replace('Foodservice Gloves', "Gants pour restauration")
                        .replace('Forks', "Fourchettes")
                        .replace('Garbage Bags', "Sacs poubelle")
                        .replace('Grocery Bags', "Sacs d'épicerie")
                        .replace('Hairnets and Bouffant Caps', "Filets pour cheveux et chapeaux bouffants")
                        .replace('Institutional', "Institutionnel")
                        .replace('Janitorial and Sanitation', "Nettoyage")
                        .replace('Knives', "Couteaux")
                        .replace('Latex Gloves', "Gants en latex")
                        .replace('Meal Kits', "Trousses de repas")
                        .replace('Medical', "Médical")
                        .replace('Medical Gloves', "Gants médicaux")
                        .replace('Nitrile Gloves', "Gants en nitrile")
                        .replace('Our Markets', "Nos Marchés")
                        .replace('Picks and Accessories', "Piques")
                        .replace('Plates and Bowls', "Assiettes et bols")
                        .replace('Poly Bags', "Sacs en poly")
                        .replace('Retail', "Vente au détail")
                        .replace('Rubber Gloves', "Gants en caoutchouc")
                        .replace('Saddle Bags', "Sacs de selle")
                        .replace('Skewers', "Brochettes")
                        .replace('Spoons', "Cuillères")
                        .replace('Steak Markers', "Marqueurs de steak")
                        .replace('Stirrers', "Mélangeurs")
                        .replace('Straws', "Pailles")
                        .replace('Takeout Containers', "Contenants à emporter")
                        .replace('Vinyl Gloves', "Gants en vinyle")
                        .replace('More info', "Plus d'Infos")
                        .replace('Eco-Friendly Products', "Produits Écologiques")
            );
            if ($jquery_isp('.isp_facet_narrowed_by_category').length > 0) {
                $jquery_isp('.isp_facet_narrowed_by_category').text(
                    $jquery_isp('.isp_facet_narrowed_by_category').text().replace('Best Sellers', "Meilleures ventes")
                        .replace('Home page', "Page d'accueil")
                        .replace('Bags', "Sacs")
                        .replace('Chef Hats and Hair Restraints', "Toques de chef et filets pour cheveux")
                        .replace('Crayons', "Crayons de cire")
                        .replace('Disposable Cutlery', "Couverts jetables")
                        .replace('Filters', "Filtres")
                        .replace('Gloves', "Gants")
                        .replace('Grill Bricks', "Briques à gril")
                        .replace('Guest Checks', "Livrets de vente")
                        .replace('Label Dispensers', "Distributeurs d'étiquettes")
                        .replace('Labels', "Étiquettes")
                        .replace('Lice Squad Boxes', "Boîtes 'Lice Squad'")
                        .replace('Muddlers', "Agitateurs")
                        .replace('Napkin Bands', "Bandes de serviette")
                        .replace('Picks and Skewers', "Piques et brochettes")
                        .replace('Pizza Holders', "Trépied à pizza")
                        .replace('Protective Wear', "Articles de protection")
                        .replace('Register Rolls', "Rouleaux de caisse")
                        .replace('Stirrers and Straws', "Agitateurs et pailles")
                        .replace('Swipes', "Swipes")
                        .replace('Containers and Cups', "Contenants et tasses à emporter")
                        .replace('Towels and Sponges', "Linges et éponges")
                        .replace('Twist Ties and Twine', "Attaches torsadées et ficelle")
                        .replace('Wipes', "Lingettes")
                        .replace('Beard Protectors', "Filets de barbe")
                        .replace('Chef Hats', "Toques de chef")
                        .replace('Chopsticks', "Baguettes")
                        .replace('Cups and Lids', "Tasses et couvercles")
                        .replace('Foodservice', "Restauration")
                        .replace('Foodservice Gloves', "Gants pour restauration")
                        .replace('Forks', "Fourchettes")
                        .replace('Garbage Bags', "Sacs poubelle")
                        .replace('Grocery Bags', "Sacs d'épicerie")
                        .replace('Hairnets and Bouffant Caps', "Filets pour cheveux et chapeaux bouffants")
                        .replace('Institutional', "Institutionnel")
                        .replace('Janitorial and Sanitation', "Nettoyage")
                        .replace('Knives', "Couteaux")
                        .replace('Latex Gloves', "Gants en latex")
                        .replace('Meal Kits', "Trousses de repas")
                        .replace('Medical', "Médical")
                        .replace('Medical Gloves', "Gants médicaux")
                        .replace('Nitrile Gloves', "Gants en nitrile")
                        .replace('Our Markets', "Nos Marchés")
                        .replace('Picks and Accessories', "Piques")
                        .replace('Plates and Bowls', "Assiettes et bols")
                        .replace('Poly Bags', "Sacs en poly")
                        .replace('Retail', "Vente au détail")
                        .replace('Rubber Gloves', "Gants en caoutchouc")
                        .replace('Saddle Bags', "Sacs de selle")
                        .replace('Skewers', "Brochettes")
                        .replace('Spoons', "Cuillères")
                        .replace('Steak Markers', "Marqueurs de steak")
                        .replace('Stirrers', "Mélangeurs")
                        .replace('Straws', "Pailles")
                        .replace('Takeout Containers', "Contenants à emporter")
                        .replace('Vinyl Gloves', "Gants en vinyle")
                        .replace('More info', "Plus d'Infos")
                        .replace('Eco-Friendly Products', "Produits Écologiques")
                );
            }
        }
    }
}